import { render, staticRenderFns } from "./ResponsibleLending.vue?vue&type=template&id=78f879ee&scoped=true"
import script from "./ResponsibleLending.vue?vue&type=script&lang=js"
export * from "./ResponsibleLending.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleLending.vue?vue&type=style&index=0&id=78f879ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f879ee",
  null
  
)

export default component.exports